import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
//   mode: 'history',
  base: '/',
  routes: [{
      path: '/login',
      name: 'Login',
      component: () => import("@/views/login")
    },
    {
      path: '/',
      name: 'Layout',
      component: ()=>import("@/layout/default"),
      children: [
        {path: '/', name: 'Index', component: () =>import("@/views/index/index")},
        {path: '/edit/password', name: 'EditPassword', component: () =>import("@/views/admin/editpassword")},
        {path: '/business/index', name: 'BusinessIndex', component: () =>import("@/views/business/index")},
        {path: '/business/order', name: 'BusinessOrder', component: () =>import("@/views/business/order")},
        {path: '/business/submit', name: 'BusinessSubmit', component: () =>import("@/views/business/submit")},
        {path: '/business/list', name: 'BusinessList', component: () =>import("@/views/business/list")},
        {path: '/business/detail', name: 'BusinessDetail', component: () =>import("@/views/business/detail")},
        {path: '/stock/index', name: 'StockIndex', component: () =>import("@/views/stock/index")},
        {path: '/shop/index', name: 'ShopIndex', component: () =>import("@/views/shop/index")},
        {path: '/money/index', name: 'MoneyIndex', component: () =>import("@/views/money/index")},
        {path: '/shop/service/project/index', name: 'ShopServiceProjectIndex', component: () =>import("@/views/shopServiceProject/index")},
        {path: '/shop/product/index', name: 'ShopProductIndex', component: () =>import("@/views/shopProduct/index")},
        {path: '/shop/group/item/index', name: 'ShopGroupItemIndex', component: () =>import("@/views/shopGroupItem/index")},
        {path: '/shop/recharge/card/index', name: 'ShopRechargeCardIndex', component: () =>import("@/views/shopRechargeCard/index")},
        {path: '/staff/index', name: 'StaffIndex', component: () =>import("@/views/staff/index")},
        {path: '/customer/index', name: 'CustomerIndex', component: () =>import("@/views/customer/index")},
        {path: '/shop/config', name: 'ShopConfig', component: () =>import("@/views/shop/config")},
        {path: '/shop/integral', name: 'ShopIntegral', component: () =>import("@/views/shop/integral")},
        {path: '/shop/list', name: 'ShopList', component: () =>import("@/views/shop/list")},
        {path: '/shop/banner/index', name: 'ShopBannerIndex', component: () =>import("@/views/shopBanner/index")},
        {path: '/shop/member/category/index', name: 'ShopMemberCategoryIndex', component: () =>import("@/views/shopMemberCategory/index")},
        {path: '/statistics/index', name: 'StatisticsIndex', component: () =>import("@/views/statistics/index")},
        {path: '/statistics/sleep', name: 'StatisticsSleep', component: () =>import("@/views/statistics/sleep")},
        {path: '/statistics/customer', name: 'StatisticsCustomer', component: () =>import("@/views/statistics/customer")},
        {path: '/statistics/customer/month', name: 'StatisticsCustomerMonth', component: () =>import("@/views/statistics/customerMonth")},
        {path: '/statistics/customer/month/money', name: 'StatisticsCustomerMonthMoney', component: () =>import("@/views/statistics/customerMonthMoney")},
        {path: '/statistics/customer/month/card/fee', name: 'StatisticsCustomerMonthCardFee', component: () =>import("@/views/statistics/customerMonthCardFee")},
        {path: '/statistics/staff/project', name: 'StatisticsStaffProject', component: () =>import("@/views/statistics/staffProject")},
        {path: '/statistics/staff/product', name: 'StatisticsStaffProduct', component: () =>import("@/views/statistics/staffProduct")},
        {path: '/statistics/staff/group', name: 'StatisticsStaffGroup', component: () =>import("@/views/statistics/staffGroup")},
        {path: '/statistics/staff/card', name: 'StatisticsStaffCard', component: () =>import("@/views/statistics/staffCard")},
        {path: '/statistics/staff/card/dikou', name: 'StatisticsStaffCardDikou', component: () =>import("@/views/statistics/staffCardDikou")},
        {path: '/statistics/staff/debt', name: 'StatisticsStaffDebt', component: () =>import("@/views/statistics/staffDebt")},
        {path: '/statistics/staff/all', name: 'StatisticsStaffAll', component: () =>import("@/views/statistics/staffAll")},
        {path: '/statistics/staff/ren', name: 'StatisticsStaffRen', component: () =>import("@/views/statistics/staffRen")},
        {path: '/statistics/staff/service/fee', name: 'StatisticsStaffServiceFee', component: () =>import("@/views/statistics/staffServiceFee")},
        {path: '/statistics/staff/card/fee', name: 'StatisticsStaffCardFee', component: () =>import("@/views/statistics/staffCardFee")},
        {path: '/statistics/service/all', name: 'StatisticsServiceAll', component: () =>import("@/views/statistics/serviceAll")},
        {path: '/statistics/service/count', name: 'StatisticsServiceCount', component: () =>import("@/views/statistics/serviceCount")},
        {path: '/statistics/product/all', name: 'StatisticsProductAll', component: () =>import("@/views/statistics/productAll")},
        {path: '/statistics/service/not', name: 'StatisticsServiceNot', component: () =>import("@/views/statistics/serviceNot")},
		//{~routers~}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js